import styled from 'styled-components';

const ReviewStyle = styled.section`
	--sizeItemSlid: calc((100vw - 2 * var(--contPaddingLR) - 2 * var(--gutter)) / 3);
	--swiperSlideWidth: calc(var(--sizeItemSlid) - 5px);
	--radiusBorder: var(--sp4x);
	--contentPadTB: var(--sp4x);
	--contentPadLR: var(--sp4x);
	--distanceStarAuthor: var(--sp2-5x);
	--distanceSliderT: var(--sp9x);
	--distanceTitleContent: var(--sp15x);
	/* --itemHeightFixed: 19vw; */

	.outer-wrapper-swiper {
		margin-top: var(--distanceSliderT);
		margin-bottom: var(--sectionDistance);
	}

	.swiper {
		padding: 0 var(--contPaddingLR);
		display: flex;
	}

	.swiper-wrapper {
		/* min-height: var(--itemHeightFixed); */

		cursor: grab;
		user-select: none;
	}

	.swiper-slide {
		width: var(--swiperSlideWidth);
		margin-right: var(--gutter);
		height: unset;

		&:last-child {
			margin-right: 0 !important;
		}
	}

	.wrapper-item {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		overflow: hidden;
		border-radius: var(--radiusBorder);
		border: 1px solid var(--neutral600);
		padding: var(--contentPadTB) var(--contentPadLR);
	}

	.wrapper-ratting-author {
		margin-top: var(--distanceTitleContent);
		display: flex;
		flex-direction: column;
		gap: var(--distanceStarAuthor);
	}

	.line-clamp-10 {
		display: -webkit-box;
		-webkit-line-clamp: 10;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceSliderT: var(--sp7x);
		/* --itemHeightFixed: 23.2vw; */

		--distanceTitleContent: var(--sp11x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--radiusBorder: var(--sp3x);
		--contentPadTB: var(--sp3x);
		--contentPadLR: var(--sp3x);
		--distanceStarAuthor: var(--sp2x);
		--distanceSliderT: var(--sp6x);
		/* --itemHeightFixed: 24.1vw; */

		--distanceTitleContent: var(--sp10x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--radiusBorder: var(--sp2-5x);
		--contentPadTB: var(--sp2x);
		--contentPadLR: var(--sp2x);
		--distanceStarAuthor: var(--sp1x);
		--distanceSliderT: var(--sp4x);
		/* --itemHeightFixed: 25vw; */

		--distanceTitleContent: var(--sp8x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--contentPadTB: var(--sp2-5x);
		--contentPadLR: var(--sp2-5x);
		/* --itemHeightFixed: 25.4vw; */

		--distanceTitleContent: var(--sp7x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--radiusBorder: var(--sp2x);
		--contentPadTB: var(--sp1-5x);
		--contentPadLR: var(--sp1-5x);
		--sizeItemSlid: calc((100vw - 2 * var(--contPaddingLR) - 2 * var(--gutter)) / 2);
		/* --itemHeightFixed: 39.1vw; */

		--distanceTitleContent: var(--sp6x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeItemSlid: calc((100vw - 2 * var(--contPaddingLR) - 2 * var(--gutter)) / 4 * 3);
		--distanceStarAuthor: var(--sp1-5x);
		--distanceSliderT: var(--sp3x);
		/* --itemHeightFixed: 60.15vw; */

		--distanceTitleContent: var(--sp3x);
	}
`;

export default ReviewStyle;
